/* eslint-disable max-len */
import React from 'react';

const AlignLeftIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M12 16v1H4v-1h8zm4.001-4v1H4v-1h12.001zM12 8v1H4V8h8zm4.001-4v1H4V4h12.001z"
            transform="translate(-417.000000, -81.000000) translate(413.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AlignLeftIcon;
